import { createSelector } from 'reselect';
import get from 'lodash/get';

export const circleSelector = state => state.board.circleOfCare;
export const reqCircleOfCareSelector = state => state.board.reqCircleOfCare;

export const careProvidersSelector = createSelector(
  circleSelector,
  circle => get(circle, 'careProviders', []),
);

export const familyCircleSelector = createSelector(
  circleSelector,
  circle => get(circle, 'familyCircle', []),
);

export const sendingReqCircleOfCareSelector = createSelector(
  reqCircleOfCareSelector,
  request => get(request, 'sending'),
);

export const selectPendingFamilyMembers = createSelector(
  circleSelector,
  state => get(state, 'pendingFamilyMembers', []),
);



// WEBPACK FOOTER //
// ./src/redux/board/selectors/circleOfCare.js